import { GridColumnHeaderParams } from "@mui/x-data-grid-pro";

import { ContainerTypesFilter } from "../../../../components/TableFilters/ContainerTypesFilter";
import { NumberFilter } from "../../../../components/TableFilters/NumberFilter";
import { RfidFilter } from "../../../../components/TableFilters/RfidFilter";
import { TextFilter } from "../../../../components/TableFilters/TextFilter";
import { WasteTypesFilter } from "../../../../components/TableFilters/WasteTypesFilter";
import { TableHeaderCell } from "../../../../components/TableHeaderCell";
import {
  removeInventorySheetFilter,
  setInventorySheetFilter,
  setInventorySheetListOrdering,
} from "../../../../reducers/inventorySheetReducer";
import {
  getInventorySheetFilterIsActive,
  getInventorySheetFilterOptionsForContainerTypes,
  getInventorySheetFilterValue,
  getInventorySheetOrderingValue,
} from "../../../../selectors/inventorySheet";
import { ColumnType } from "../InventorySheetTableColumnTypes";

const TABLE_NAME = "inventoryList";

interface IHeaderCellProps {
  params: GridColumnHeaderParams;
}

const selectFilters = (type: string) => {
  switch (type) {
    case ColumnType.collectionPointName:
    case ColumnType.street:
    case ColumnType.streetNumber:
    case ColumnType.barcode:
      return (
        <TextFilter
          tableName={TABLE_NAME}
          fieldName={type}
          filterSelectorValue={getInventorySheetFilterValue}
          filterUpdateAction={setInventorySheetFilter}
        />
      );
    case ColumnType.wasteType:
      return (
        <WasteTypesFilter
          tableName={TABLE_NAME}
          fieldName={type}
          filterSelectorValue={getInventorySheetFilterValue}
          filterUpdateAction={setInventorySheetFilter}
        />
      );
    case ColumnType.containerType:
      return (
        <ContainerTypesFilter
          tableName={TABLE_NAME}
          fieldName={type}
          filterSelectorValue={getInventorySheetFilterValue}
          filterUpdateAction={setInventorySheetFilter}
          optionsSelectorValue={getInventorySheetFilterOptionsForContainerTypes}
        />
      );
    case ColumnType.rfid:
      return (
        <RfidFilter
          tableName={TABLE_NAME}
          fieldName={type}
          filterSelectorValue={getInventorySheetFilterValue}
          filterUpdateAction={setInventorySheetFilter}
        />
      );
    case ColumnType.pointId:
    case ColumnType.householdMembersCount:
      return (
        <NumberFilter
          tableName={TABLE_NAME}
          fieldName={type}
          filterSelectorValue={getInventorySheetFilterValue}
          filterUpdateAction={setInventorySheetFilter}
        />
      );
    default:
      <div />;
  }
};

export const InventorySheetTableHeaderCell: React.FC<IHeaderCellProps> = ({ params }) => {
  return (
    <TableHeaderCell
      tableName={TABLE_NAME}
      params={params}
      selectorOrdering={getInventorySheetOrderingValue}
      selectorFilterIsActive={getInventorySheetFilterIsActive}
      removeFilterUpdateAction={removeInventorySheetFilter}
      selectFilters={selectFilters}
      orderingUpdateAction={setInventorySheetListOrdering}
    />
  );
};
